module.exports = __webpack_public_path__ + "static/media/haute15E.cf52ae25.jpg";